import { observable, action, runInAction} from 'mobx'
import { json } from '../../../../../utils/ajax'

class faultDCodeContentStore {
  @observable loading
  @observable content
  @observable carseriesName


  constructor () {
    this.loading = false;
    this.content = '';
    this.carseriesName = '';
  }
  @action
  init = async(id) =>{
    runInAction(()=>{
      this.loading = true;
    })
    const carSeries = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultDiagnosis/faultDiagnosisCarseriesCatalog/id/${id}`)
    if(carSeries && carSeries.status === 0){
      runInAction(()=>{
        this.loading = false
      })
      return
    }
    const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/faultDiagnosis/faultDiagnosisCode/searchCarBelowCode?carseriesId=${id}`)
      if(res && res.status === 0){
      runInAction(()=>{
        this.loading = false
        this.content = '该车系下暂无数据！'
      })
      return
      }
    runInAction(()=>{
      this.carseriesName = carSeries.carseriesName;
      this.content = res.faultDescription
      this.loading = false;
    })
  }
}
export default new faultDCodeContentStore()


// WEBPACK FOOTER //
// ./src/project/dongfeng/faultDiagnosis/main/CodeContent/store.js